import React from 'react';
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { FooterContainerStyled } from './styled';
export function FooterContainer(props) {
    return (React.createElement(FooterContainerStyled, null,
        React.createElement(ResponsiveGrid, { ...props })));
}
FooterContainer.displayName = 'FooterContainer_Component';
